import styled from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
export var Wrapper = withTheme(styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "ssphlx-0"
})(["width:", ";height:", ";"], function (p) {
  return p.size;
}, function (p) {
  return p.size;
}));